import define from '@ingka/webc-tools';
import Icon from './src/Icon.js';
import { renderIconDOM } from './src/tools/svg-renderer.js';
export { Icon, renderIconDOM };
export const iconTagName = define('icon', Icon);
